// Loads the Supabase client on first use instead of at startup, so its ~210 KB
// (auth, realtime, storage, postgrest) stays out of the bundle every page must
// parse before first render. Code on the startup path should use this; lazily
// loaded pages can keep importing "./client" directly.
import type { supabase as SupabaseClient } from "./client";

let clientPromise: Promise<typeof SupabaseClient> | null = null;

// A password-reset email signs the visitor in and sends them back with
// "type=recovery" in the URL hash. supabase-js consumes and clears that hash as
// soon as it starts, so it is read here, when the entry bundle loads.
//
// The hash is the only signal used. supabase-js also fires a PASSWORD_RECOVERY
// event, but it repeats it in every other open tab of the site, and a tab left
// on a product page must not be pulled to the password form. The tab the link
// opened always arrives with the hash (the client uses the implicit flow).
let passwordRecovery = typeof window !== "undefined" && /(^|[#&])type=recovery(&|$)/.test(window.location.hash);

export function getSupabase(): Promise<typeof SupabaseClient> {
  clientPromise ??= import("./client").then((m) => m.supabase);
  return clientPromise;
}

/** True while this visit is the return from a password-reset email. */
export const isPasswordRecovery = () => passwordRecovery;

/** Call once the new password is saved, or the visitor chooses not to set one. */
export const endPasswordRecovery = () => {
  passwordRecovery = false;
};
